/**
 * Sprint B — Badge marche_status (statut financier de la tâche).
 *
 * Rendu compact — visible dans drawer, dashboard, terrain.
 * Statuts :
 *  - inclus      : vert      (ligne DPGF rattachée + lot attribué)
 *  - a_chiffrer  : orange    (devis complémentaire en cours)
 *  - hors_marche : rouge     (lot attribué mais pas couvert)
 *  - pre_marche  : gris-bleu (chantier pas encore en marché ou lot non attribué)
 */
import { CheckCircle, Coins, WarningCircle, Hourglass } from '@phosphor-icons/react';

const CONFIG = {
  inclus:      { label: 'Inclus marché',     bg: '#E8F3EE', fg: '#2D6A4F', icon: CheckCircle },
  a_chiffrer:  { label: 'À chiffrer',        bg: '#FDF1E1', fg: '#C4773B', icon: Coins },
  hors_marche: { label: 'Hors marché',       bg: '#FCE8E8', fg: '#C00000', icon: WarningCircle },
  pre_marche:  { label: 'Pré-marché',        bg: '#EEF2F7', fg: '#1E3A5F', icon: Hourglass },
};

export default function MarcheStatusBadge({ status, size = 'sm', testId = 'marche-status-badge' }) {
  const cfg = CONFIG[status] || CONFIG.pre_marche;
  const Icon = cfg.icon;
  const px = size === 'xs' ? 'px-1.5 py-0.5 text-[9px]' : 'px-2 py-1 text-[10px]';
  const iconSize = size === 'xs' ? 10 : 12;
  return (
    <span
      className={`inline-flex items-center gap-1 ${px} font-bold uppercase tracking-wider rounded-none whitespace-nowrap`}
      style={{ background: cfg.bg, color: cfg.fg }}
      data-testid={testId}
      data-status={status || 'pre_marche'}
      title={cfg.label}
    >
      <Icon size={iconSize} weight="bold" />
      {cfg.label}
    </span>
  );
}
